import React from "react";

const HEIGHTS = { sm: 20, md: 28, lg: 36 };

export default function BrandLogo({ size = "md", variant = "full", className = "" }) {
  const h = HEIGHTS[size] || HEIGHTS.md;
  if (variant === "mark") {
    return <img src="/android-chrome-192x192.png" alt="MyQuoteFlow" width={h} height={h}
      style={{ width: h, height: h }} className={`shrink-0 ${className}`} data-testid="brand-logo-mark" />;
  }
  return <img src="/logo-header.png" srcSet="/logo-header.png 1x, /logo-header@2x.png 2x, /logo-header@3x.png 3x"
    alt="MyQuoteFlow" style={{ height: h, width: "auto" }} className={`shrink-0 ${className}`} data-testid="brand-logo" />;
}
